import React, { Fragment, useEffect, useState } from "react";
import BackWithLabel from "@/components/common/BackWithLabel";
import CardComponent from "@/components/card";
import Container from "@/components/container/Container";
import { Col, Row } from "antd";
import IconSessionName from "@/components/icons/IconSessionName";
import IconCalender from "@/components/icons/IconCalender";
import IconSessionTime from "@/components/icons/IconSessionTime";
import ButtonComponent from "@/components/button/Button";
import "@/styles/pages/guide/guide-sessions.scss";
import { getBookedSessions } from "@/services/users/getBookedSessions";
import { useNavigate } from "react-router-dom";
import { convertToLocalTime } from "@/helpers";
import { getCountryTimeZone } from "@/helpers/getCountryZone";
import Session from "@/pages/session/Session";
import IconReschedule from "@/components/icons/IconReshedule";
import { setCurrentForm, setFormProps, setModalOpen } from "@/reducers/commonSlice";
import { useDispatch } from "react-redux";
import { showNotification } from "@/components/toaster/Toaster";
import { Flex } from "antd";
import { rescheduleSession } from "@/services/guides/session";

const Sessions = () => {
  const [sessionData, setSessionData] = useState([]);
  const [timezone, setTimezone] = useState();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    setTimezone(getCountryTimeZone());
  }, []);

  const fetchData = async () => {
    getBookedSessions()
      .then((res) => {
        const updatedData = res?.map((x) => ({
          ...x,
          ...convertToLocalTime(x.date, x.time),
        }));
        setSessionData(updatedData);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleJoinSession = (id) => {
    navigate(`/guide/lobby/${id}`);
  };

  const handleRescheduleSession = async (sessionItem) => {
    // Open the "request with reason" modal form.
    dispatch(setCurrentForm("requestWithReason"));
    dispatch(setModalOpen(true));
    dispatch(
      setFormProps({
        message: "Are you sure you want to request a session reschedule?",
        onSubmit: (data) => {
          // Validate that a comment was entered.
          if (!data.comment || data.comment.trim() === "") {
            showNotification("error", "Error", "Please enter your comment");
            return;
          }
          const payload = {
            reason: data.comment,
            bookingId: sessionItem.id,
          };
          rescheduleSession(payload)
            .then((res) => {
              fetchData();
              showNotification(
                "success",
                "Registered!",
                "Your reschedule request has been registered."
              );
            })
            .catch((err) => console.log(err));
          dispatch(setModalOpen(false));
        },
      })
    );
  };

  return (
    <Fragment>
      <div className="guide-session-wrapper">
        <Container>
          <CardComponent>
            <div className="header">
              <div className="back-button">
                <BackWithLabel label="My Sessions" path="/dashboard" />
              </div>
            </div>

            <div className="sessions">
              <Row gutter={[16, 16]}>
                {sessionData.length ? (
                  sessionData.map((item, index) => (
                    <Col key={index} xxl={8} xl={8} lg={12} md={24} sm={24} xs={24}>
                      <div className="session-card">
                        <CardComponent>
                          <div className="session-card-header">
                            <div className="context body-b4">Session with</div>
                          </div>

                          <div className="name">
                            <div className="picture">
                              <img src="/assets/images/profile.svg" alt="" />
                            </div>
                            <div className="fullname body-b2">{item.studentName}</div>
                          </div>

                          <Flex className="sesstion-name" gap="0.5rem">
                            <IconSessionName />
                            <span className="text-grey">Session Name:</span>
                            <span className="text-black">{item.name}</span>
                          </Flex>

                          <Flex className="session-date" gap="0.5rem">
                            <IconCalender />
                            <span className="text-grey">Date:</span>
                            <span className="text-black">{item.date}</span>
                          </Flex>

                          <Flex className="session-time" gap="0.5rem">
                            <IconSessionTime />
                            <span className="text-grey">Time:</span>
                            <span className="text-black">
                              {item.time} {timezone ? `(${timezone})` : ""}
                            </span>
                          </Flex>

                          <div className="session-button">
                            <ButtonComponent
                              varient="success"
                              label="Start Session"
                              onClick={() => handleJoinSession(item.id)}
                            />
                          </div>

                          <div className="cancel-button">
                            <ButtonComponent
                              varient="outline-danger"
                              label="Cancel Session"
                              disabled
                            />
                          </div>

                          <div className="session-button" style={{ paddingTop: "1rem" }}>
                            <ButtonComponent
                              label="Reschedule Session"
                              iconRight={false}
                              onClick={() => handleRescheduleSession(item)}
                            >
                              <IconReschedule width="24px" height="24px" color="#db5800" />
                            </ButtonComponent>
                          </div>
                        </CardComponent>
                      </div>
                    </Col>
                  ))
                ) : (
                  <Flex className="w-100" justify="center">
                    <Session isGuidePanel />
                  </Flex>
                )}
              </Row>
            </div>
          </CardComponent>
        </Container>
      </div>
    </Fragment>
  );
};

export default Sessions;
